import { hotComics } from "@/mocks/comics";

export function formatViewsHelper(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export { hotComics };